import { RatingEvent } from '@21st-night/review';

export function getTotalStudyTime(ratingEvents: RatingEvent[]): number {
  return ratingEvents.reduce(
    (totalTime, ratingEvent) => totalTime + ratingEvent.duration || 0,
    0,
  );
}
